'use strict';

class PkFloater {

    constructor(utils) {
        "ngInject";

        _.extend(this, {
            restrict: 'A',
            controller: this.controller,
            controllerAs: 'pkFloater',
            scope: {
                track: '@pkFloater'
            }
        });

        this.utils = utils;
    }

    link(scope, element, attrs) {
        let watchedElement = document.querySelector("[pk-component-id='"+ scope.track +"']");

        window.addEventListener('scroll', _.throttle(() => {
            let rect = watchedElement.getBoundingClientRect();
            ( rect.top >= 0 && rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) ? (element[0].style.visibility = "hidden", element[0].style.opacity = 0) : (element[0].style.visibility = "visible", element[0].style.opacity = 1);
        }, 250));
    }

}

export default PkFloater;


// WEBPACK FOOTER //
// ./client/app/common/pk.floater/pk.floater.js